<div class="kiosk-container" [class.kiosk-container--website]="isWebsite">
  <router-outlet></router-outlet>
</div>

<!-- Idle standby / screensaver. Inert unless the merchant enabled it. -->
<app-standby-overlay></app-standby-overlay>
